/* Config */
import appConfig from '../../appConfig'

/* Utils */
import {resolveWithSettleContext} from '../../common/async/promiseUtils'
import {getChildIds} from './cmsComponentUtils'

function cmsComponentApiFactory(storefrontApiClient) {
  const isBrowser = process.env.BROWSER && window;
  const apiUrl = !isBrowser && appConfig.stargateServerUrl
    ? appConfig.stargateServerUrl
    : appConfig.stargateUrl;

  const cmsComponentApi = {
    getCmsComponent(cmsComponents) {
      return Promise.all(
        cmsComponents.reduce((promiseList, cmsComponent) => {
          if (cmsComponent.onlyClientSide && !isBrowser) {
            return promiseList;
          }

          promiseList.push(
            resolveWithSettleContext(
              storefrontApiClient.get(`${apiUrl}/getcmscomponent`, {
                params: {
                  id: cmsComponent.id,
                  name: cmsComponent.name,
                  tagId: cmsComponent.tagId,
                  categoryId: cmsComponent.categoryId,
                  shouldLoadEagerly: cmsComponent.shouldLoadEagerly,
                  autoRotate: cmsComponent.autoRotate,
                  showArrowsOnlyOnHover: cmsComponent.showArrowsOnlyOnHover,
                  disableRetinaSupport: cmsComponent.disableRetinaSupport,
                  sliderDots: cmsComponent.sliderDots,
                  childIds: getChildIds(cmsComponent),
                  withoutHTML: cmsComponent?.onlyClientSide && '',
                  platform: cmsComponent?.platform,
                  isBot: cmsComponent?.isBot,
                },
              },
              null
              ).then(res => {
                return res.data;
              }).
                catch((e) => {
                  console.log(`Failed to fetch ${cmsComponent.type} - getcmscomponent ${cmsComponent.id} ${e.message}`);
                }),
            ));
          return promiseList;
        }, []),
      );
    },
    getDeliveryTooltips(id) {
      return storefrontApiClient.get(`${appConfig.converterUrl}/api/deliverytooltips/${id}`)
    }
  }

  return cmsComponentApi
}

export default cmsComponentApiFactory
